import type { ReactNode } from 'react';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { CdStepItem, type CdStepItemProps } from '../../molecules/CdStepItem';
import { cx } from '../../utils';
import styles from './CdStepsSection.module.scss';

export interface CdStepsSectionProps {
  title: ReactNode;
  subtitle?: string;
  description?: string;
  steps: Omit<CdStepItemProps, 'step'>[];
  tone?: 'plain' | 'muted';
  className?: string;
}

/** "How it works" / "New to PermiOne" – three numbered steps with dividers. */
export const CdStepsSection = ({
  title,
  subtitle,
  description,
  steps,
  tone = 'plain',
  className,
}: CdStepsSectionProps) => {
  return (
    <section className={cx(styles.section, styles[tone], className)}>
      <CdHeading level={2} size="lg">
        {title}
      </CdHeading>
      {subtitle && <CdText variant="label">{subtitle}</CdText>}
      {description && <CdText tone="secondary">{description}</CdText>}
      <ol className={styles.steps}>
        {steps.map((step, index) => (
          <li key={step.title} className={styles.step}>
            <CdStepItem step={index + 1} {...step} />
          </li>
        ))}
      </ol>
    </section>
  );
};
